import { useEffect, useState } from "react";
import transactionService from "../../services/transactionService";
import { Transaction } from "../../models/interfaces";
import ComboBox from "../../components/controls/ComboBox";
import FindAccount from "../../components/controls/FindAccount/FindAccount";
import FormCommand from "../../components/controls/FormCommand";
import TextBox from "../../components/controls/TextBox/TextBox";
import FormModal from "../../components/controls/FormModal";
import GridView from "../../components/controls/GridView/GridView";
import { MdAdd } from "react-icons/md";
import Frame from "../../components/controls/Frame/Frame";
import CheckBox from "../../components/controls/Checkbox/CheckBox";
import ContextMenu from "../../components/controls/ContextMenu/ContextMenu";
import { MenuItem } from "../../models/menu";

export interface TransactionListingPageProps {
  displayHeader?: boolean;
}

export function getTransactionContextMenu(): MenuItem<Transaction>[] {
  return [
    new MenuItem("delete", () => {
      alert("Transaction deleted");
    }),

    new MenuItem("Reverse", () => {
      alert("Transaction reverse");
    }),
  ];
}

export const TransactionListingPage = (props: TransactionListingPageProps) => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [displayManualPostingForm, setDisplayManualPostingForm] =
    useState(false);

  const getTransactions = async () => {
    const resp = await transactionService.getTransactions({
      narration: "",
    });

    if (resp.status) {
      setTransactions(resp.data ?? []);
    }
  };

  useEffect(() => {
    getTransactions();
  });

  return (
    <>
      <div className="row">
        <div className="col">
          <Frame>
            <h4>Transactions</h4>
            <GridView
              showSearchBar={true}
              name={"lstTransactions"}
              context="Transactions"
              showAddButton={true}
              onAddRecord={() => {
                setDisplayManualPostingForm(true);
              }}
              onSearchClick={() => console.log("Search clicked!")}
            >
              <GridView.Header>
                <thead>
                  <tr>
                    <th>Reference</th>
                    <th>Narration</th>
                    <th>Amount</th>
                    <th>Transaction Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
              </GridView.Header>
              <GridView.Content>
                {transactions.map((d) => (
                  <tr>
                    <td>{d.transactionRef}</td>
                    <td> {d.narration}</td>
                    <td>{d.amount}</td>
                    <td>{d.transactionDate?.toDateString()}</td>
                    <td>
                      <ContextMenu
                        item={d}
                        menu={getTransactionContextMenu()}
                      />
                    </td>
                  </tr>
                ))}
              </GridView.Content>
            </GridView>
          </Frame>
        </div>
      </div>

      {displayManualPostingForm && (
        <FormModal onClose={() => setDisplayManualPostingForm(false)}>
          <ManualPostingForm></ManualPostingForm>
        </FormModal>
      )}
    </>
  );
};

export type ManualPostingFormProps = {};
export const ManualPostingForm = (props: ManualPostingFormProps) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="row">
          <div className="col">
            <FindAccount id="debitAccount" text="Debit Account " />
          </div>
          <div className="col">
            <FindAccount id="creditAccount" text="Credit Account" />
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <TextBox
              type="number"
              id="amount"
              text="Amount"
              step={100}
              min={0}
            />
          </div>
          <div className="col-4">
            <ComboBox
              id="debitCredit"
              prompt="Select Debit Or Credit"
              text="DR / CR"
              items={[
                { id: "DR", name: "Debit" },
                { id: "CR", name: "Credit" },
              ]}
            />
          </div>
          <div className="col-4" style={{ paddingTop: "15px" }}>
            <CheckBox
              id="mergeTransactions"
              text="Merge Transactions"
              type="switchbox"
            />
            <CheckBox
              id="useSameTransactionRef"
              text="Use same Reference"
              type="switchbox"
            />
          </div>
        </div>

        <TextBox
          id="narration"
          text="Narration"
          isMultiLine={true}
          maxRows={2}
        />

        <div className="form-group" style={{ margin: "10px 0" }}>
          <button id="btnAdd" className="btn btn-outline-primary btn-sm">
            <MdAdd size={20} />
            Save changes
          </button>
        </div>

        <div className="form-group">
          <div className="table table-responsive">
            <table className="table table-striped">
              <thead>
                <th>Debit Account</th>
                <th>Credit Account</th>
                <th>Amount</th>
                <th>DR/CR</th>
                <th>Narration</th>
                <th>Action</th>
              </thead>
            </table>
          </div>
        </div>

        <FormCommand commandText="Post Transactions" />
      </div>
    </div>
  );
};

export type OpeningBalancePageProps = {};

export function OpeningBalancePage(props: OpeningBalancePageProps) {
  return (
    <div className="row">
      <div className="col">
        <FindAccount id="accountId" text="Select Account" />
        <div className="row">
          <div className="col">
            <TextBox id="amount" type="number" text="Amount" />
          </div>
          <div className="col">
            <ComboBox
              id="debitCreditType"
              text="Select"
              prompt="Select DRCR"
              items={[
                { id: "DR", name: "Debit" },
                { id: "CR", name: "Credit" },
              ]}
            />
          </div>
        </div>
        <TextBox
          id="narration"
          text="Narration"
          placeholder="Enter narration"
          maxRows={3}
          isMultiLine={true}
        />
        <FormCommand />
      </div>
    </div>
  );
}
